/**
 * The maximum screen width the Sidebar will be displayed in.
 * Derived from sass-assets.
 * @type {Number}
 */
export const MAX_DISPLAY_WIDTH = 900;
